/* eslint-disable @typescript-eslint/no-require-imports */
import type React from "react";

import CustomPlatform from "$src/core/utils/platform/platform";

import type { SubscriptionOfferCardProps } from "./types";

export default CustomPlatform.select<
  () => React.FC<SubscriptionOfferCardProps>
>({
  tv: () => require("./SubscriptionOfferCard.tv").default,
  default: () => require("./SubscriptionOfferCard").default,
})();
